import AxiosInterceptor from "../utils/AxiosInterceptor";

const categoryManagementApi = {
  add: (value) => AxiosInterceptor().post('/addCategory', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllCategories`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneCategory/${values.id}`),
  updateCategory: (values) => AxiosInterceptor().post(`/updateCategory`, values),
  deleteCategory: (values) => AxiosInterceptor().get(`/deletecategory/${values.id}`, ),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatusCategory`, values),

};

const DashboardApi = {
  getDashboardReports : (values) => AxiosInterceptor().post('/getDashboardReports',values),
  customerLastLogin : (values) => AxiosInterceptor().post('/customerLastLogin',values),
  dealerLastLogin : (values) => AxiosInterceptor().post('/dealerLastLogin',values),
}

const productManagementApi = {
  add: (value) => AxiosInterceptor().post('/addProduct', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllProducts`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneProduct/${values.id}`),
  updateProduct: (values) => AxiosInterceptor().post(`/updateProduct`, values),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatusProduct`, values),
  deleteProduct: (values) => AxiosInterceptor().get(`/deleteProduct/${values.id}`, ),
  getAllCategoryForProducts: (values) => AxiosInterceptor().post('/getAllDropdownCategory', values),
  getAllDealersForDropdown: () => AxiosInterceptor().get('/getAllDealersForDropdown'),
  removeDealerQuantity: (values) => AxiosInterceptor().post('/removeDealerQuantity', values),
  stockUpdate: (values) => AxiosInterceptor().post('/stockUpdate', values),
  getProductStock: (values) => AxiosInterceptor().post('getProductStock',values),
};

const dealerManagementApi = {
  add: (value) => AxiosInterceptor().post('/addDealer', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllDealers`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneDealer/${values.id}`),
  updateDealer: (values) => AxiosInterceptor().post(`/updateDealer`, values),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatusDealer`, values),
  allDropDownCategory: (values) => AxiosInterceptor().post(`/allDropDownCategory`, values),
  deleteDealer: (values) => AxiosInterceptor().get(`/deleteDealer/${values.id}`, ),
  approveDealer: (values) => AxiosInterceptor().post(`/approveDealer`, values),
}

const customerManagementApi = {
  add: (value) => AxiosInterceptor().post('/addUser', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllUsers`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneUser/${values.id}`),
  updateUser: (values) => AxiosInterceptor().post(`/updateUser`, values),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatusUser`, values),
  deleteUser: (values) => AxiosInterceptor().get(`/deleteUser/${values.id}`, ),
}

const orderManagementApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllOrders`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneOrder/${values.id}`),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatusOfOrder`, values),
};

const deliveryPartnerManagementApi = {
  add: (value) => AxiosInterceptor().post('/addDriver', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllDriver`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneDriver/${values.id}`),
  updateDriver: (values) => AxiosInterceptor().post(`/updateDriver`, values),
  changeStatus: (values) => AxiosInterceptor().post(`/changeDriverStatus`, values),
  deleteDriver: (values) => AxiosInterceptor().post(`/deleteDriver`,values ),
  blockDriver: (values) => AxiosInterceptor().post(`/blockDriver`, values),
  getAllDealersDropDown: (values) => AxiosInterceptor().post('/getAllDealersDropDown', values),
}


const paymentApi = {
  add: (value) => AxiosInterceptor().post('/addContent', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllPayments`, values),
  getById: (values) => AxiosInterceptor().get(`/getOnePayment/${values.id}`, ),
  updateUser: (values) => AxiosInterceptor().post(`/changeStatusOfPayment`, values),
  refundAmount: (values) => AxiosInterceptor().post(`/refund`, values),
}

const cmsApi = {
  add: (value) => AxiosInterceptor().post('/addContent', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllContent`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneContent/${values.id}`, ),
  updateUser: (values) => AxiosInterceptor().post(`/updateContent`, values),
}

const timeSlotManagementApi = {
  add: (value) => AxiosInterceptor().post('/addTimeSlot', value),
  getAll: (values) => AxiosInterceptor().post(`/getAllTimeSlot`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneTimeSlot/${values.id}`),
  updateTimeSlot: (values) => AxiosInterceptor().post(`/updateTimeSlot`, values),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatus`, values),
  deleteTimeSlot: (values) => AxiosInterceptor().get(`/deleteTimeSlot/${values.id}`),
}


const emailTemplateApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllTemplate`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneTemplate/${values.id}`),
  changeStatus: (values) => AxiosInterceptor().post(`/changeStatusEmailTemplate`, values),
  update: (values) => AxiosInterceptor().post(`/updateTemplate`, values),
  add: (values) => AxiosInterceptor().post(`/addTemplate`, values),
  delete: (values) => AxiosInterceptor().get(`/deleteTemplate/${values.id}`),
};

const subAdminServcie = {
  getAll: (values) => AxiosInterceptor().post(`/getAllSubadmin`, values),
  getById: (values) => AxiosInterceptor().get(`/getSubAdminDetails/${values.id}`),
  add: (values) => AxiosInterceptor().post(`/addSubadmin`, values),
  edit: (value) => AxiosInterceptor().post(`/updateSubAdmin`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteSubAdmin`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeSubadminStatus`, value),
};

const rateAndReviewApi = {
  getAll: (values) => AxiosInterceptor().post(`/getallreviews`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneReview/${values.id}`),
}

const reportsAndAnalyticsApi = {
  getUserReport: (values) => AxiosInterceptor().post(`/getReports`, values),
  getAllDrivers: (values) => AxiosInterceptor().post(`/getAllDrivers`,values),
  getAllDealers: (values) => AxiosInterceptor().post(`/getAllDealers`,values),
}

const NotificatiopnApi = {
  enableNotification: (values) => AxiosInterceptor().post(`/enableNotification`, values),
  getNotificationSetting: () => AxiosInterceptor().get(`/getNotificationSetting`),
  addNotificationTemplate: (values) => AxiosInterceptor().post('/addNotificationTemplate',values),
  getAllNotificationTemplate: (values) => AxiosInterceptor().post('/getAllNotificationTemplate',values),
  getOneNotificationTemplate: (id) => AxiosInterceptor().post(`/getOneNotificationTemplate/${id}`),
  updateNotificationTemplate: (values) => AxiosInterceptor().post('/updateNotificationTemplate',values),
  deleteNotificationTemplate: (values) => AxiosInterceptor().post('/deleteNotificationTemplate',values),
  changeStatus: (values) => AxiosInterceptor().post('/changeNotificationStatus',values),
  getUsers: () => AxiosInterceptor().get('/getUsers'),
  sendNotificationToUsers : (value) => AxiosInterceptor().post('/sendNotificationToUsers', value),
}

const dealerCommissionApi = {
  getAllDealerCommission: (values) => AxiosInterceptor().post(`/getAllDealerCommission`, values),
  getOneDealerCommission: (values) => AxiosInterceptor().get(`/getOneDealerCommission/${values.id}`),
  updateDealerCommission: (values) => AxiosInterceptor().post(`/updateDealerCommission`, values),
}

const LanguageApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllLanguages`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneLanguage/${values.id}`),
  add: (values) => AxiosInterceptor().post(`/addLanguage`, values),
  edit: (value) => AxiosInterceptor().post(`/updateLanguage`, value),
  delete: (value) => AxiosInterceptor().get(`/deleteLanguage/${value.id}`),
  changeStatus: (value) => AxiosInterceptor().post(`/changeStatusLanguage`, value),
};

const customerQueryApi = {
  getAllSupport: (values) => AxiosInterceptor().post(`/getAllSupport`, values),
  getOneSupport: (values) => AxiosInterceptor().get(`/getOneSupport/${values.id}`),
  resolveQuery: (values) => AxiosInterceptor().post(`/resolveQuery`, values),
}


export default {
  categoryManagementApi,
  productManagementApi,
  subAdminServcie,
  rateAndReviewApi,
  dealerManagementApi,
  customerManagementApi,
  cmsApi,
  emailTemplateApi,
  orderManagementApi,
  timeSlotManagementApi,
  deliveryPartnerManagementApi,
  paymentApi,
  reportsAndAnalyticsApi,
  NotificatiopnApi,
  dealerCommissionApi,
  LanguageApi,
  customerQueryApi,
  DashboardApi
};
